export function nonEmptyString(s?: string | null): s is string {
  return s !== undefined && s !== null && s.length > 0;
}
